module.exports = __webpack_public_path__ + "static/media/bonusSpins_20_25.cdc8d358.png";